import {
  useDashboardUIActions,
} from "@contexts/dashboardUI";
import Cookies from "universal-cookie";
import { createAuthenticatedFetch } from "@utils/authenticatedFetch";

const cookies = new Cookies();
const bimFetch = createAuthenticatedFetch({
  serverUrl: process.env.BIM_SERVER_URL,
  getToken: () => cookies.get("userId")?.token,
});

export default (state, dispatch) => {
  const fetch = bimFetch;

  const updateIndex = async (item) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.BIM_SERVER_URL}/bim/updateIndex`, {
      method: "POST",
      body: JSON.stringify({ name: item })
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { code: response.status, message }
  }

  return {
    updateIndex,
  };

};
